import PropTypes from "prop-types";
import { Button } from "@monitor/platform/capture";

// Adapter: keeps the legacy GeneralButton API (`type`, `submit`, `element`) so
// every existing call site works unchanged, while rendering the migrated
// platform Button underneath. The legacy `type` maps onto the platform
// `variant`; an unknown type falls back to `ghost`.
const TYPE_TO_VARIANT = {
  primary: "primary",
  "primary-invert": "secondary",
  secundary: "tertiary",
  "secundary-invert": "primary",
  default: "ghost"
};

const GeneralButton = props => {
  const {
    element,
    onClick,
    type,
    // Platform Button size ('sm' | 'md' | 'lg'). Defaults to 'md' to match the
    // platform default; change this default to resize every capture button at
    // once, or pass `size` per call site to resize a single one.
    size = "lg",
    disabled,
    className,
    children,
    submit,
    id,
    style
  } = props;

  return (
    <Button
      variant={TYPE_TO_VARIANT[type] ?? "ghost"}
      size={size}
      // Legacy `submit` bool → native button type. Note: the old button set no
      // type when `submit` was falsy, so it defaulted to "submit" (a latent
      // bug); non-submit buttons are now explicitly "button".
      type={submit ? "submit" : "button"}
      onClick={onClick}
      disabled={disabled}
      className={className}
      id={id}
      style={style}
    >
      {children}
      {element}
    </Button>
  );
};

GeneralButton.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.node,
    PropTypes.array
  ]),
  onClick: PropTypes.func,
  type: PropTypes.oneOf([
    "primary",
    "primary-invert",
    "secundary",
    "secundary-invert"
  ]),
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.node,
    PropTypes.array
  ]),
  submit: PropTypes.bool
};

export default GeneralButton;
